// extracted by mini-css-extract-plugin
export default {"dropdown-menu":"styles__dropdown-menu--sX+jC"};